import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'app-checkbox',
  templateUrl: './checkbox.component.html',
  styleUrls: ['./checkbox.component.scss']
})
export class CheckboxComponent implements OnInit {

  @Input()
  checked

  @Input()
  checkboxValue

  @Input() id: string;
  @Input() class: string;

  @Input()
  displayText


  @Output()
  returnCheckboxValue = new EventEmitter


  constructor() { }

  ngOnInit() {
  }

  selectChoice(event) {
    this.returnCheckboxValue.emit(event)
  }

}
